<template>
  <div class="mobilePage" @click="pageClick">
    <div
      class="hero"
      @click.stop="
        getApkInfo(os.isPhone && switchData.shopIosDownUrl ? 'shopIos' : true, $event)
      "
    >
      <div class="scrimBottom"></div>
      <div class="scrimTop"></div>
      <div class="headerBox">
        <div class="logoWrap">
          <div class="logo"></div>
          <span class="logoText">花魁短剧</span>
        </div>
        <div class="headerLinks" v-if="configs && configs.length">
          <div class="linkItem" v-if="cTg" @click.stop="jumpUrl(cTg)">
            <div class="linkIcon telegram"></div>
            <span>TG</span>
          </div>
          <div class="linkItem" v-if="cPotato" @click.stop="jumpUrl(cPotato)">
            <div class="linkIcon potato"></div>
            <span>土豆</span>
          </div>
          <div class="linkItem" v-if="cBusiness" @click.stop="jumpUrl(cBusiness)">
            <div class="linkIcon business"></div>
            <span>商务</span>
          </div>
          <div class="linkItem" v-if="cChannel" @click.stop="jumpUrl(cChannel)">
            <div class="linkIcon channel"></div>
            <span>渠道</span>
          </div>
        </div>
      </div>
    </div>

    <div class="heroContent" :class="{ heroContentAndroid: !os.isPhone }">
      <div class="copyBox">
        <div class="titleBox">
          <div class="titleImg"></div>
          <div class="subTitle">三分钟一集，海量原创短剧每日更新，免费看，不卡顿</div>
        </div>
        <div class="tagList">
          <div class="tag" v-for="item in tags" :key="item">{{ item }}</div>
        </div>
      </div>

      <div class="btnGroup" v-if="os.isPhone">
        <div
          class="btn btnPrimary"
          v-if="switchData.shopIosDownUrl"
          @click.stop="getApkInfo('shopIos', $event)"
        >
          <div class="btnIcon appleIcon"></div>
          <span>下载 iOS 商店版</span>
          <div class="recommendTag">推荐</div>
        </div>
        <div
          class="btn"
          :class="switchData.shopIosDownUrl ? 'btnOutline' : 'btnPrimary'"
          @click.stop="getApkInfo(true, $event)"
        >
          <div class="btnIcon appleIcon"></div>
          <span>iOS 轻量版</span>
        </div>
        <div class="btnTip">轻量版无需 App Store，用 Safari 打开即可安装</div>
      </div>
      <div class="btnGroup" v-else>
        <div class="btn btnPrimary" @click.stop="onLiteDownload($event)">
          <div class="btnIcon androidIcon"></div>
          <span>下载 Android 版</span>
        </div>
        <div class="btnTip">APK 直接安装，无需商店账号</div>
      </div>
    </div>

    <!-- 安装引导 -->
    <van-overlay
      :show="iosPromptShow || androidPromptShow"
      z-index="999"
      class="guideOverlay"
    >
      <div class="guideWrap">
        <div class="guideCard" @click.stop>
          <div class="guideTitle">{{ guide.title }}</div>
          <div class="guideDesc">{{ guide.desc }}</div>
          <div class="guideDivider"></div>
          <div class="guideSteps">
            <div class="guideStep" v-for="(step, index) in guide.steps" :key="index">
              <div class="stepIndex">{{ index + 1 }}</div>
              <div class="stepText">
                <div class="stepTitle">{{ step.title }}</div>
                <div class="stepDesc">{{ step.desc }}</div>
              </div>
            </div>
          </div>
          <div class="guideNotice">{{ guide.notice }}</div>
          <div class="guideConfirm" @click="closeGuide">我知道了</div>
          <div class="guideHelp" @click.stop="openOnlineService($event)">
            安装遇到问题？查看常见问题
          </div>
        </div>
        <div class="guideClose" @click.stop="closeGuide"></div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import getCustomerServiceUrl from "@/api/getCustomerServiceUrl";
import {
  getDeviceType,
  getSystemType,
  getSystemVersion,
  getTraceId,
  landingPageClick,
} from "@/utils/eventTracker";

const APPID = 216;

const GUIDES = {
  ios: {
    title: "安装 iOS 轻量版",
    desc: "免 App Store，三步完成，约 1 分钟",
    steps: [
      {
        title: "允许下载描述文件",
        desc: "在 Safari 中点击「iOS 轻量版」，系统提示时选择「允许」。",
      },
      {
        title: "安装描述文件",
        desc: "前往「设置」，点击顶部「已下载描述文件」，选择「安装」并输入锁屏密码。",
      },
      {
        title: "返回桌面打开",
        desc: "桌面出现「花魁短剧」图标后，点开即可观看。",
      },
    ],
    notice:
      "仅支持 Safari；在微信或 Telegram 内请先点右上角，选择「在浏览器中打开」。",
  },
  android: {
    title: "安装 Android 版",
    desc: "下载 APK，三步完成",
    steps: [
      {
        title: "下载安装包",
        desc: "点击「下载 Android 版」，下载完成后在通知栏或下载列表点击打开。",
      },
      {
        title: "允许安装未知来源",
        desc: "提示「禁止安装来源不明的应用」时，点「设置」开启允许后返回安装。",
      },
      {
        title: "打开花魁短剧",
        desc: "安装完成后点击「打开」，或在桌面找到「花魁短剧」图标。",
      },
    ],
    notice: "安装时如提示风险，属于安全软件误报，可放心继续安装。",
  },
};

export default {
  props: ["os", "configs", "switchData"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      currUrl: window.location.href,
      tags: ["原创短剧", "每日上新", "高清秒播"],
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      onlineServiceLoading: false,
      version: "A",
    };
  },
  computed: {
    guide() {
      return this.iosPromptShow ? GUIDES.ios : GUIDES.android;
    },
  },
  watch: {
    configs(configs) {
      configs.forEach((item) => {
        if (item.configType === "tg_group") {
          this.cTg = item.link;
        } else if (item.configType === "potato_group") {
          this.cPotato = item.link;
        } else if (item.configType === "sw_cooperate") {
          this.cBusiness = item.link;
        } else if (item.configType === "qd_cooperate") {
          this.cChannel = item.link;
        }
      });
      return configs;
    },
  },
  methods: {
    pageClick(event) {
      landingPageClick(this, {
        tab_key: "main",
        tab_name: "主页",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY,
      });
    },
    checkIsSafari() {
      const ua = (this.os.userAgent || "").toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    onLiteDownload(event) {
      if (this.os.isPhone && !this.checkIsSafari()) {
        this.showTip = true;
        landingPageClick(this, {
          tab_name: "下载按钮",
          tab_key: "download",
          click_coordinates_x: event.clientX,
          click_coordinates_y: event.clientY,
        });
        return;
      }
      this.getApkInfo(true, event);
    },
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          console.log("复制成功");
          this.showTip = false;
        },
        () => {
          console.log("复制失败");
        },
      );
    },
    closeGuide() {
      this.iosPromptShow = false;
      this.androidPromptShow = false;
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(flag, event) {
      let type = "android";
      if (this.os.isPhone) {
        type = "ios";
        if (flag === "shopIos") {
          type = "shopIos";
        }
      } else {
        type = "android";
      }
      if (flag == "androidSpare") {
        type = "androidSpare";
      }
      if (flag && flag !== "shopIos") {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY,
      });
    },
    jumpUrl(url) {
      window.open(url);
    },
    openMobileCompatibleUrl(url) {
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    async openOnlineService(event) {
      const click_coordinates_x = event.clientX;
      const click_coordinates_y = event.clientY;
      const userAgent = this.os.userAgent || "";
      landingPageClick(this, {
        tab_name: "在线客服",
        tab_key: "customer_service",
        click_coordinates_x,
        click_coordinates_y,
      });
      if (this.onlineServiceLoading) {
        return;
      }
      this.onlineServiceLoading = true;
      try {
        const res = await getCustomerServiceUrl({
          uid: this.$route.query.uid || getTraceId(),
          appId: APPID,
          deviceType: getDeviceType(userAgent),
          systemType: getSystemType(userAgent),
          systemVersion: getSystemVersion(userAgent),
        });
        const serviceUrl = res && res.data && res.data.data;
        if (serviceUrl) {
          this.openMobileCompatibleUrl(serviceUrl);
          return;
        }
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
      } catch (error) {
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
        console.log("get customer service url error:", error);
      } finally {
        this.onlineServiceLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #ff0f53;
$brandLight: #ff3d74;
$pageBg: #141414;

.mobilePage {
  height: 100%;
  width: 100%;
  background-color: $pageBg;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  font-family: "PingFang SC", -apple-system, "Helvetica Neue", Arial, sans-serif;
  color: #fff;

  .hero {
    position: relative;
    width: 100%;
    height: 390px;
    background: url("./../../../assets/images/mobileA/hero.webp") no-repeat
      center;
    background-size: cover;

    .scrimBottom {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        rgba(20, 20, 20, 0) 0%,
        rgba(20, 20, 20, 0) 45%,
        $pageBg 100%
      );
    }

    .scrimTop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 140px;
      background: linear-gradient(
        180deg,
        $pageBg 0%,
        rgba(20, 20, 20, 0.6) 40%,
        rgba(20, 20, 20, 0) 100%
      );
    }
  }

  .headerBox {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 56px;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;

    .logoWrap {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .logo {
      width: 32px;
      height: 32px;
      background: url("./../../../assets/images/mobileA/logo.png") no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
    }

    .logoText {
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      white-space: nowrap;
    }

    .headerLinks {
      display: flex;
      align-items: flex-start;
      gap: 17px;
    }

    .linkItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      width: 24px;

      span {
        font-size: 10px;
        letter-spacing: 0.8px;
        line-height: 1;
        white-space: nowrap;
      }
    }

    .linkIcon {
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .telegram {
      background-image: url("./../../../assets/images/mobileA/telegram.png");
    }
    .potato {
      background-image: url("./../../../assets/images/mobileA/potato.png");
    }
    .business {
      background-image: url("./../../../assets/images/mobileA/business.png");
    }
    .channel {
      background-image: url("./../../../assets/images/mobileA/channel.png");
    }
  }

  .heroContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 0 16px calc(20px + env(safe-area-inset-bottom));
    box-sizing: border-box;
    width: 100%;

    &.heroContentAndroid {
      gap: 40px;
      padding-top: 20px;
    }
  }

  .copyBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
  }

  .titleBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;

    .titleImg {
      width: 329px;
      height: 114px;
      background: url("./../../../assets/images/mobileA/title.webp") no-repeat;
      background-size: 100% 100%;
    }

    .subTitle {
      width: 100%;
      color: #b9bbc2;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      text-align: center;
    }
  }

  .tagList {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    .tag {
      height: 24px;
      padding: 0 12px;
      border-radius: 999px;
      background: rgba(255, 15, 83, 0.16);
      color: $brandLight;
      font-size: 12px;
      font-weight: 500;
      line-height: 24px;
      white-space: nowrap;
    }
  }

  .btnGroup {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 48px;
    padding: 0 24px;
    box-sizing: border-box;
    border-radius: 999px;

    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      white-space: nowrap;
    }

    .btnIcon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .appleIcon {
      background-image: url("./../../../assets/images/mobileA/icon-apple.png");
    }

    .androidIcon {
      background-image: url("./../../../assets/images/mobileA/icon-android.png");
    }

    .recommendTag {
      position: absolute;
      top: -8px;
      right: -4px;
      height: 20px;
      padding: 0 8px;
      border-radius: 999px;
      background: #fff;
      color: $brand;
      font-size: 11px;
      font-weight: 500;
      line-height: 20px;
      white-space: nowrap;
    }
  }

  .btnPrimary {
    background: $brand;
  }

  .btnOutline {
    border: 1px solid #6b6d77;
  }

  .btnTip {
    width: 100%;
    color: #7e818b;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }

  .guideOverlay {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(20, 20, 20, 0.9);
  }

  .guideWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .guideCard {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 311px;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background: #26272f;

    .guideTitle {
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      text-align: center;
    }

    .guideDesc {
      width: 100%;
      color: #7e818b;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
    }

    .guideDivider {
      width: 100%;
      height: 1px;
      background: #33343c;
    }

    .guideSteps {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }

    .guideStep {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      width: 100%;
    }

    .stepIndex {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      border-radius: 999px;
      background: rgba(255, 15, 83, 0.16);
      color: $brandLight;
      font-size: 12px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
    }

    .stepText {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
      min-width: 0;
    }

    .stepTitle {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }

    .stepDesc {
      color: #b9bbc2;
      font-size: 12px;
      line-height: 18px;
    }

    .guideNotice {
      width: 100%;
      padding: 8px 12px;
      box-sizing: border-box;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.05);
      color: #7e818b;
      font-size: 12px;
      line-height: 18px;
    }

    .guideConfirm {
      width: 100%;
      height: 44px;
      margin-top: 24px;
      border-radius: 999px;
      background: $brand;
      font-size: 16px;
      font-weight: 500;
      line-height: 44px;
      text-align: center;
    }

    .guideHelp {
      width: 100%;
      color: $brandLight;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
    }
  }

  .guideClose {
    width: 36px;
    height: 36px;
    background: url("./../../../assets/images/mobileA/guide-close.png")
      no-repeat;
    background-size: 100% 100%;
  }
}
.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;
  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }
  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }
  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }
  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
